import axios from 'axios'

class TKSService {
    constructor() {
        let token = 'pNJDWUGZMvW8HO7SiOqka07gJJIbZcB7tYKBdJluSpmabr8Ccpd7cWkNxSIA'
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('token') !== null) {
            token = urlParams.get('token');
        }
        console.log(token)
        this.api = axios.create({
            baseURL: process.env.VUE_APP_GET_HOST,
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });
    }

    getPerformanceCard(performanceID) {
        return this.api.get(`/api/v1/events`,
            {
                params: {
                    event_id: performanceID
                }
            });
    }

    getPerformanceHallPlan(performanceID) {
        return this.api.get(`/api/v1/sections`,
            {
                params: {
                    event_id: performanceID
                }
            });
    }

    getPerformanceTickets(performanceID, sectionID) {
        return this.api.get(`/api/v1/places`,
            {
                params: {
                    event_id: performanceID,
                    section_id: sectionID
                }
            });
    }

    createCustomer(email, name, phone, subscribe) {
        return this.api.post(`/api/v1/customers`,
            {
                email,
                name,
                phone,
                subscribe
            });
    }

    createOrder(customer_id, pushka) {
        return this.api.post(`/api/v1/orders`,
            {
                customer_id,
                pushka
            });
    }
    checkPromoCode(promo_code, event_id, places) {
        return this.api.post(`/api/v1/tks/promo-codes/check`,
            {
                promo_code,
                event_id,
                places
            });
    }

    addPlacesToOrder(order_id, places_ids,promo_code) {
        return this.api.patch(`/api/v1/orders/add-places`,
            {
                order_id,
                places_ids,
                promo_code
            });
    }

    getCouponsInfo(performanceID) {
        return this.api.post(`/api/v1/tks/coupons/check`,
            {
                event_id: performanceID
            });
    }

    payOrder(order_id, sum, pushka, client_id, event_id, promo_code, counters = [], places = []) {
        return this.api.post(`/api/v1/sber/orders`,
            {
                order_id,
                sum,
                pushka,
                client_id,
                promo_code,
                counters,
                event_id,
                places
            });
    }
}

export default TKSService;
